"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Ensure reflect metadata polyfill available
require("reflect-metadata");
/*** Ensure parts of window needed to prevent crash are present ***/
if (!window)
    window = {};
if (!window.location)
    window["location"] = window["location"] || {};
if (!window.location.pathname) {
    window["location"].pathname =
        typeof window["location"].pathname === "string" ? window["location"].pathname : "";
}
var location = window.location;
var pathname = (location && location["pathname"]) ||
    (window && window["location"] && window["location"].pathname) ||
    (document && document["location"] && document["location"].pathname);
/************************************** SET UP MOMENT LOCALE **************************************/
var moment_1 = __importDefault(require("moment"));
if (pathname && pathname.includes("/fr/")) {
    require('moment/locale/fr-ca');
    moment_1.default.locale("fr-ca");
}
/************************************** LOG & INSPECT SETUP ***************************************/
require("./log-config");
/**************************************** APPLY POLYFILLS *****************************************/
require("./extend-kotlin-array");
require("./extend-kotlin-empty-list");
require("./extend-kotlin-hash-map");
require("./polyfills");
// Ensure kotlin exists on window
window["kotlin"] = window["kotlin"] || require('kotlin');
/************************ TOP-LEVEL OBJECT (ARRAY, OBJECT, ETC.) OVERRIDES ************************/
var core_object_detection_override_1 = require("./core-object-detection-override");
core_object_detection_override_1.applyArrayDetectionOverrides();
/*********************************** ACTIVATE MOBX STRICT MODE ************************************/
var mobx_1 = require("mobx");
/**
 * Turn MobX strict mode on
 * Should prevent direct modification of the store outside of action methods
 * (i.e. ensures mobx mutation is only allowed through actions)
 */
mobx_1.configure({ enforceActions: "observed" });
//# sourceMappingURL=setup.js.map